import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Hotfix 2026-05-23 (FE-139) — alias route.
 *
 * CLAUDE.md документирует API path как `/api/v1/finance/regulatory/{esf,kpn}`,
 * поэтому QA bulk-scan / docs links могут целиться в `/finance/regulatory/esf`.
 * FE-стороне канонический маршрут короче — `/finance/esf` — этот alias
 * redirect'ит на него, чтобы не выдавать «Not Found».
 */
export const Route = createFileRoute('/_auth/finance/regulatory/esf')({
  beforeLoad: () => {
    throw redirect({ to: '/finance/esf' });
  },
});
